var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":!_vm.loaded,"column":""}},[(_vm.loaded)?_vm._t("default"):_c('v-layout',{staticClass:"align-center justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }